import { api } from './auth.service';

const colaboradorService = {

  listar: async () => {
    const res = await api.get('/colaboradores');
    return res.data;
  },

  // r167d: versão LEVE pra combos. Bate em /colaboradores/referencia — liberado a
  // QUALQUER autenticado, sem checagem de rotina E sem o filtro "só os meus".
  // Resolve os combos de vendedor/resp. técnico em telas de quem não tem acesso
  // (ou tem acesso com filtro) ao cadastro de Colaboradores. Aceita:
  //   listarReferencia()                       → todos os ativos
  //   listarReferencia({ q: 'ana' })           → autocomplete por texto
  //   listarReferencia({ vendedor: true })     → só vendedores
  //   listarReferencia({ resp_tecnico: true }) → só responsáveis técnicos
  listarReferencia: async (params = {}) => {
    const res = await api.get('/colaboradores/referencia', { params });
    return res.data;
  },

  buscarPorId: async (id) => {
    const res = await api.get(`/colaboradores/${id}`);
    return res.data;
  },

  incluir: async (dados) => {
    const res = await api.post('/colaboradores', dados);
    return res.data;
  },

  alterar: async (id, dados) => {
    const res = await api.put(`/colaboradores/${id}`, dados);
    return res.data;
  },

  alterarStatus: async (id, status) => {
    const res = await api.patch(`/colaboradores/${id}/status`, { status });
    return res.data;
  },

  // Lista usuários com perfil Colaborador para o combo de vínculo
  listarUsuariosColaborador: async () => {
    const res = await api.get('/colaboradores/usuarios-disponiveis');
    return res.data;
  },
};

export default colaboradorService;
